import AddItemDialog from "../../Dialogs/AddItemDialog";
import Box from "@mui/system/Box";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useState } from "react";
import { LayoutExamLabel, LayoutExamTypeKeys } from "../../../enums/layoutExamTypes";
import { setLayoutType } from "../Functions/FunctionsCreatePages";
import { useSelector } from "react-redux";
import { RootState } from "../../..";
import { updateExamSettings } from "../Functions/FunctionsMain";

const ChangeLayoutDialog = ({ open, handleCancel }: { open: boolean; handleCancel: () => void }) => {
  const printSolutions = useSelector((state: RootState) => state.examBuilder.print.printSolutions);
  const createPageNumbers = useSelector((state: RootState) => state.examBuilder.print.createPageNumbers);
  const selectedLayout = useSelector((state: RootState) => state.examBuilder.createPages.layoutType);
  const [layout, setLayout] = useState<LayoutExamTypeKeys>(selectedLayout);

  const user = useSelector((state: RootState) => state.app.user);
  const userId = user?.uid;

  const handleChange = (event: SelectChangeEvent) => {
    setLayout(event.target.value as LayoutExamTypeKeys);
  };

  const handleConfirm = async () => {
    if (layout !== selectedLayout && userId) {
      await updateExamSettings(userId, printSolutions, createPageNumbers, layout);
    }
    setLayoutType(layout);
  };

  return (
    <AddItemDialog
      open={open}
      handleCancel={handleCancel}
      handleConfirm={() => handleConfirm()}
      title={"Layout auswählen"}
      description={"Wähle ein Layout für deine Prüfung."}
      confirmText={"OK"}
      confirmAllowed={true}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "12px" }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Layout</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={layout}
            label="Layout"
            onChange={handleChange}
          >
            {Object.entries(LayoutExamLabel).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}></Box>
    </AddItemDialog>
  );
};

export default ChangeLayoutDialog;
